<template>
  <div>
    <div class="card">
      <ToolbarHeader
        :title="pageTitle"
        :loading-refresh="loadingRefresh"
        @create="sendToForm('Create')"
        @refresh="getData()"
        :show-export-buttons="false"
      />
      <div class="card-body">
        <a-table
                style="
                  margin-left: -26px;
                  margin-right: -26px;
                  margin-top: -21px;
                "
          :columns="columns"
          :dataSource="data"
          :rowKey="record => record.id"
          size="small"
          :pagination="{
            defaultPageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal: (total) => `Total ${total} items`,
            pageSizeOptions: ['10', '20', '30'],
          }"
        >
          <div slot="filterDropdown"
            slot-scope="{setSelectedKeys, selectedKeys, confirm,
              clearFilters, column,}"
            style="padding: 8px;"
          >
            <a-input
              v-ant-ref="(c) => (searchInput = c)"
              :placeholder="`Search ${column.title}`"
              :value="selectedKeys[0]"
              style="width: 188px; margin-bottom: 8px; display: block;"
              @change="
                (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
              "
              @pressEnter="
                () => handleSearch(selectedKeys, confirm, column.dataIndex)
              "
            />
            <a-button
              type="primary"
              icon="search"
              size="small"
              style="width: 90px; margin-right: 8px;"
              @click="
                () => handleSearch(selectedKeys, confirm, column.dataIndex)
              "
            >
              Search
            </a-button>
            <a-button
              size="small"
              style="width: 90px;"
              @click="() => handleReset(clearFilters)"
            >
              Reset
            </a-button>
          </div>
          <a-icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
          />
          <template
            slot="customRender"
            slot-scope="text, record, index, column"
          >
            <span v-if="searchText && searchedColumn === column.dataIndex">
              <template
                v-for="(fragment, i) in text
                  .toString()
                  .split(
                    new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')
                  )"
              >
                <mark
                  v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                  :key="i"
                  class="highlight"
                  >{{ fragment }}</mark
                >
                <template v-else>{{ fragment }}</template>
              </template>
            </span>
            <template v-else>
              <span>
                {{ text }}
              </span>
            </template>
          </template>
          <span slot="action" slot-scope="text, record">
            <a-icon
              type="edit"
              class="text-warning"
              @click="sendToForm('Update', record, record.id)"
              />
            <a-divider type="vertical"/>
            <a-icon
              type="delete"
              class="text-danger"
              @click="showDeleteConfirm(record)"
              />
          </span>
          <template slot="appLists" slot-scope="text, record">
            <a-tag v-for="(data, index) in record.appLists" :key="index">{{ data.appName }}</a-tag>
          </template>
          <template slot="periode" slot-scope="text">
            <label>{{ moment(text, 'YYYY-MM-DD').format('DD-MM-YYYY') }}</label>
          </template>
        </a-table>
      </div>
    </div>
    <formModal ref="formModal" :key="componentKey" :table="table" />
  </div>
</template>

<script>
import ToolbarHeader from '@/components/ToolbarHeader.vue'
import * as lou from '@/services/data/lou'
import formModal from '../form'
import moment from 'moment'
import { createFilterableColumn, createActionColumn, createSimpleColumn } from '@/utils/tableColumns'

const data = []

export default {
  components: {
    formModal,
    ToolbarHeader,
  },
  data() {
    return {
      name: 'TablesAntdBasic',
      pageTitle: 'BankApp Management',
      loadingRefresh: false,
      searchText: '',
      searchInput: null,
      searchedColumn: '',
      columns: [
        createActionColumn(),
        createFilterableColumn('id', null, () => { this.searchInput.focus(); }),
        createFilterableColumn('sandibpr', 'Kode Sandi', () => { this.searchInput.focus(); }),
        createFilterableColumn('namabpr', 'Company Name', () => { this.searchInput.focus(); }),
        createSimpleColumn('appLists', 400),
        createSimpleColumn('periode'),
      ],
      table: '',
      // form: this.$form.createForm(this, { name: 'Form ' + this.table }),
      data,
      componentKey: 0,
    }
  },
  mounted: function () {
    this.getData()
  },
  methods: {
    moment,
    sendToForm(action, data = {}, id = '') {
      this.$refs.formModal.showModal(action, data, id)
    },
    async getData() {
      this.loadingRefresh = true
      this.data = []
      var res = await lou.readMaster('manage/bank', false, true, true)
      this.data = res.data
      this.loadingRefresh = false
    },
    async showDeleteConfirm(deldata) {
      await lou.confirmDelete('manage/bank', deldata.id, this.getData)
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm()
      this.searchText = selectedKeys[0]
      this.searchedColumn = dataIndex
    },

    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
  },
}
</script>
